document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-accordion').forEach(initFaqAccordion);
});

// Support sections added later via the theme editor (Shopify section rendering API)
document.addEventListener('shopify:section:load', function (event) {
  var el = event.target.querySelector('.faq-accordion');
  if (el) initFaqAccordion(el);
});

function initFaqAccordion(root) {
  if (!root || root.dataset.faqInit) return;
  root.dataset.faqInit = 'true';

  var tabs = root.querySelectorAll('[data-faq-tab]');
  var panels = root.querySelectorAll('[data-faq-panel]');

  function activateTopic(topicId) {
    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-faq-tab') === topicId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-faq-panel') === topicId);
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activateTopic(tab.getAttribute('data-faq-tab'));
    });
  });

  // Accordion expand/collapse per question
  root.querySelectorAll('[data-faq-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      var answer = button.nextElementSibling;
      var expanded = button.getAttribute('aria-expanded') === 'true';

      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (answer) answer.hidden = expanded;
    });
  });
}